import React from "react";
import { NewTab, PageTab } from "../../../../components";
import BarChartList from "./ChartsList/BarChartList";
import AreaChartList from "./ChartsList/AreaChartList";
import TableChartList from "./ChartsList/TableChartList";
import PieChartList from "./ChartsList/PieChartList";

const ChartsList = () => {
  const tabList = [
    {
      title: "Bar Chart",
      page: <BarChartList />,
      type: "main",
    },
    {
      title: "Area Chart",
      page: <AreaChartList />,
      type: "main",
    },
    {
      title: "Table Chart",
      page: <TableChartList />,
      type: "main",
    },
    {
      title: "Pie Chart",
      page: <PieChartList />,
      type: "main",
    },
  ];
  return (
    <div className="mt-5 flex-1 flex overflow-hidden">
      <NewTab
        tabs={tabList}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="charts-list"
      />
    </div>
  );
};

export default ChartsList;
